import { render, staticRenderFns } from "./studentUppTs.vue?vue&type=template&id=2035c433&scoped=true&"
import script from "./studentUppTs.vue?vue&type=script&lang=js&"
export * from "./studentUppTs.vue?vue&type=script&lang=js&"
import style0 from "./studentUppTs.vue?vue&type=style&index=0&id=2035c433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2035c433",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
